import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import style from '../../../style/components/profile/emails/EmailVerifiedNotification.module.scss';

const EmailVerifiedNotification = ({ onDismiss }) => {
  const { t } = useTranslation();

  return (
    <div className={style.notification} role="status" aria-live="polite">
      <button
        type="button"
        className={style.closeButton}
        onClick={onDismiss}
        aria-label={t('walletEmails.emailVerifiedCloseLabel')}
      >
        ✕
      </button>
      <div className={style.content}>
        <p className={style.title}>{t('walletEmails.emailVerifiedTitle')}</p>
        <span className={style.icon} aria-hidden="true">
          <idme-icon name="check-circle" size="large" color="green" />
        </span>
      </div>
    </div>
  );
};

EmailVerifiedNotification.propTypes = {
  onDismiss: PropTypes.func.isRequired,
};

export default memo(EmailVerifiedNotification);
